module.exports = __webpack_public_path__ + "img/delete-icon.6bac5007.svg";